import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import draggable from 'vuedraggable'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)

export default (data) => {

    const vm = new Vue({
        el: '#customer-voice-content',
        components: {
            'draggable': draggable,
        },
        data: {
            customer_voices: data.customer_voices,
            customer_voice_public_flg: data.customer_voice_public_flg,
            customer_voice_description: data.customer_voice_description,
            errors: data.errors,
        },
        methods: {
            addCustomerVoice: function () {
                // 末尾のsort_noを取得
                const last_sort_no = this.customer_voices[this.customer_voices.length - 1].sort_no;

                // customer_voice 配列末尾に新しい要素を追加
                this.customer_voices.push({
                    title: '',
                    comment: '',
                    sort_no: last_sort_no + 1,
                });
            },
            deleteCustomerVoice(sort_no) {
                this.customer_voices = this.customer_voices.filter(customer_voice => customer_voice.sort_no !== sort_no);
                // 番号を詰める
                this.customer_voices.forEach((customer_voice, index) => {
                    customer_voice.sort_no = index + 1;
                });
            },
            draggableEnd: function (index) {
                this.resetErrors();

            },
            deleteCustomerVoice(sort_no) {
                this.customer_voices = this.customer_voices.filter(customer_voice => customer_voice.sort_no !== sort_no);
                // 番号を詰める
                this.customer_voices.forEach((customer_voice, index) => {
                    customer_voice.sort_no = index + 1;
                });
                $(`#dialog_delete_item_${sort_no}`).modal('hide');
            },
            resetErrors: function () {
                console.log("resetErrors");
                this.errors = {};
            },
            onChangePageOpen(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('show');
              },
            modalCancel(event) {
                this.modal = $('#dialog_publish');
                this.customer_voice_public_flg = !this.customer_voice_public_flg;
                this.modal.modal('hide');
            },
            modalSettings(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('hide');
            },
        },
        computed: {
            option: function () {
                return function (index) {
                    return {
                        animation: 100,
                        handle: '.drag_handle',
                        ghostClass: 'ghost',
                        group: {
                            name: 'customer_voice'
                        }
                    };
                }
            },
        }
    });
}
